export default {
  description: 'Gebruik code: {{code}} voor korting op je volgende {{count}} bestellingen hier.',
  discounts: {
    percentage: '{{discount}}%',
    fixed: '{{discount}}',
  },
  list: {
    item: {
      order: '{{orderNumber}}. Bestelling',
    },
  },
  savings: {
    percentage: 'Je bespaart in totaal {{totalSaved}}%',
    fixed: 'Je bespaart in totaal {{totalSaved}}',
  },
  apply: 'Toepassen',
  applied: 'Toegepast',
  remove: 'Verwijderen',
  custom_button: {
    done: 'Klaar',
  },
};
